import { Injectable } from '@angular/core';

import { PromotionModel, TYPE_MARKETING } from '@bytel/bytel-sales';

@Injectable({
    providedIn: 'root',
})
export class PromotionsHelper {
    public static GetPromotionsByMarketingType(promotions: PromotionModel[], type: TYPE_MARKETING): PromotionModel[] {
        return promotions
            .filter((promotion) => promotion.typesMarketing?.includes(type))
            .sort((a, b) => a.amount - b.amount);
    }
}
